












import { GtButton } from '@speedshop/template';
export default {
  scrollToTop: true,
  name: 'NotFoundPage',
  components: {
    GtButton
  },
  data() {
    return {
      count: 5,
      timer: null
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    handleGoHome() {
      this.$router.replace({ name: 'home' });
    },
    init() {
      this.timer = setInterval(() => {
        this.count--;
        if (this.count === 1) {
          clearInterval(this.timer);
          this.timer = null;
          this.handleGoHome();
        }
      }, 1000);
    }
  }
};
